import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const demographicsListGlobalIsLoadingSelector = (state: AppState) => state.demographics.listGlobal.isLoading;
export const useDemographicsListGlobalIsLoadingSelector = () => useSelector(demographicsListGlobalIsLoadingSelector);

export const demographicsListGlobalIsLoadedSelector = (state: AppState) => state.demographics.listGlobal.isDataFetched;
export const useDemographicsListGlobalIsLoadedSelector = () => useSelector(demographicsListGlobalIsLoadedSelector);

export const demographicsListGlobalRegionsSelector = (state: AppState) => state.demographics.listGlobal.regions;
export const useDemographicsListGlobalRegionsSelector = () => useSelector(demographicsListGlobalRegionsSelector);
